module.exports = __webpack_public_path__ + "img/mobile-product-case-index-retail.99062ff6.png";